'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'ice-cream';
var width = 448;
var height = 512;
var aliases = [127848];
var unicode = 'f810';
var svgPathData = 'M80 160C80 80.5 144.5 16 224 16S368 80.5 368 160c0 9.6-.9 18.9-2.7 27.9l-1.3 6.6 6.2 2.4C397 207.4 416 233.5 416 264l0 40-384 0 0-40c0-30.5 19-56.6 45.8-67.1l6.2-2.4-1.3-6.6c-1.8-9-2.7-18.4-2.7-27.9zM224 0c-88.4 0-160 71.6-160 160 0 8.4 .6 16.6 1.9 24.7-29.5 14.2-49.9 44.4-49.9 79.3l0 56 82 0 116.8 207.7 9.2 16.3 9.2-16.3 116.8-207.7 82 0 0-56c0-35-20.4-65.1-49.9-79.3 1.2-8 1.9-16.3 1.9-24.7 0-88.4-71.6-160-160-160zM331.6 320L224 511.4 116.4 320 331.6 320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIceCream = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;